import { Navigate } from "react-router";
import { useAtomValue } from "jotai";
import { accountsAtom, selectedAccountAtom } from "../stores/galaxy";
import { authAtom } from "../stores/auth";

/**
 * Redirects "/" to "/:default-account/". Tries (1) the selectedAccount
 * mirror (typically the user's last-visited galaxy in this session),
 * (2) the JWT user's login (their personal galaxy), (3) the first known
 * galaxy from useGalaxyInit's enumeration.
 *
 * No localStorage hint anymore — that was the source of the bleed bug
 * (atom seeded from previous session pointed at a galaxy the user no
 * longer had access to). See feedback_galaxy_url_truth.
 */
export default function GalaxyRedirect() {
  const selectedAccount = useAtomValue(selectedAccountAtom);
  const accounts = useAtomValue(accountsAtom);
  const auth = useAtomValue(authAtom);
  const account = selectedAccount || auth.user?.login || accounts[0] || "";

  if (!account) return null; // useGalaxyInit hasn't resolved yet
  return <Navigate to={`/${account}`} replace />;
}
